const addToCart = async (formData) => {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to add to cart");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding to cart:", error);
    throw error;
  }
};

const rerender = async () => {
  try {
    const headerSection = document.querySelector("#shopify-section-header");
    const sidecartSection = document.querySelector("#shopify-section-sidecart");

    const response = await fetch(`/?sections=header,sidecart`);
    const sections = await response.json();

    const parser = new DOMParser();

    if (sections.header) {
      const headerDoc = parser.parseFromString(sections.header, "text/html");

      const existingCartCount =
        headerSection.querySelector(".Header__CartCount");
      const existingCartDot = headerSection.querySelector(".Header__CartDot");

      if (existingCartCount) {
        const newCartCount = headerDoc.querySelector(".Header__CartCount");
        if (newCartCount) {
          existingCartCount.textContent = newCartCount.textContent;
        }
      }

      if (existingCartDot) {
        const newCartDot = headerDoc.querySelector(".Header__CartDot");
        if (newCartDot) {
          if (newCartDot.classList.contains("is-visible")) {
            existingCartDot.classList.add("is-visible");
          } else {
            existingCartDot.classList.remove("is-visible");
          }
        }
      }
    }

    if (sections.sidecart && sidecartSection) {
      const sidecartDoc = parser.parseFromString(
        sections.sidecart,
        "text/html",
      );
      const newSidecartProducts = sidecartDoc.querySelector(
        ".side-cart__products",
      );

      if (newSidecartProducts) {
        const existingProducts = sidecartSection.querySelector(
          ".side-cart__products",
        );
        if (existingProducts) {
          existingProducts.innerHTML = newSidecartProducts.innerHTML;
        }
      }

      const newFooter = sidecartDoc.querySelector(".side-cart__footer");
      const existingFooter =
        sidecartSection.querySelector(".side-cart__footer");
      if (newFooter && existingFooter) {
        existingFooter.innerHTML = newFooter.innerHTML;
      }

      const existingEmpty = sidecartSection.querySelector(".side-cart__empty");
      const newEmpty = sidecartDoc.querySelector(".side-cart__empty");
      if (existingEmpty && newEmpty) {
        existingEmpty.innerHTML = newEmpty.innerHTML;
      } else if (newEmpty && !existingEmpty) {
        const productsContainer = sidecartSection.querySelector(
          ".side-cart__products",
        );
        if (productsContainer) {
          productsContainer.insertAdjacentHTML(
            "beforebegin",
            newEmpty.outerHTML,
          );
        }
      } else if (existingEmpty && !newEmpty) {
        existingEmpty.remove();
      }
    }
  } catch (error) {
    console.error("Error rerendering sections:", error);
  }
};



// Exposed so other add-to-cart entry points (e.g. assets/pdm-product-quick-buy.js) can reuse
// the exact same add + refresh flow instead of re-implementing it against /cart/add.js and the
// header/sidecart sections by hand.
window.pdmSideCart = { addToCart, rerender };

const hijackAddToCart = () => {
  const addToCartButton = document.querySelector(".ProductForm__AddToCart");

  if (!addToCartButton) return;

  const newButton = addToCartButton.cloneNode(true);
  addToCartButton.parentNode.replaceChild(newButton, addToCartButton);

  newButton.addEventListener("click", async (e) => {
    e.preventDefault();

    const productForm = document.querySelector(".ProductForm");
    const formData = new FormData(productForm);
    const quantity = formData.get("quantity") || 1;
    const variantId = formData.get("id");

    newButton.setAttribute("disabled", true);

    if (!variantId) {
      const selectedVariant = productForm.querySelector(
        '[name="id"]:not([disabled])',
      );
      if (!selectedVariant) {
        console.error("No variant selected");
        return;
      }
    }

    const payload = {
      items: [
        {
          id: variantId || productForm.querySelector('[name="id"]')?.value,
          quantity: parseInt(quantity, 10),
        },
      ],
    };

    try {
      await addToCart(payload);
      await rerender();
      document.dispatchEvent(new CustomEvent("sidecart:open", {}));
      newButton.removeAttribute("disabled");
    } catch (e) {
      console.error("Failed to add to cart:", e);
      newButton.classList.add("error");
    }
  });
};

(() => {
  console.log("pdm sidecart");

  const observer = new MutationObserver(() => {
    if (document.body.hasAttribute("data-pdm-features")) {
      observer.disconnect();
      hijackAddToCart();

      class Sidecart extends HTMLElement {
        connectedCallback() {
          document.addEventListener("sidecart:open", this.open.bind(this));
          document.addEventListener("sidecart:close", this.close.bind(this));

          this.sidecartBackdrop = document.querySelector(
            ".side-cart__backdrop",
          );

          this.querySelector(".side-cart__close").addEventListener(
            "click",
            () => {
              this.close();
            },
          );

          this.sidecartBackdrop.addEventListener("click", () => {
            this.close();
          });
        }

        open() {
          this.classList.add("open");
          this.sidecartBackdrop.classList.add("open");
        }

        close() {
          this.classList.remove("open");
          this.sidecartBackdrop.classList.remove("open");
        }
      }

      class SidecartProduct extends HTMLElement {
        connectedCallback() {
          const removeButton = this.querySelector(".side-cart__product-remove");
          if (removeButton) {
            removeButton.addEventListener("click", this.remove.bind(this));
          }
        }

        async remove(e) {
          e.preventDefault();
          e.stopPropagation();
          const id = this.getAttribute("id");
          this.querySelector(".side-cart__product").classList.add("loading");
          console.log("index", this.getAttribute("index"));
          try {
            await fetch("/cart/change.js", {
              method: "POST",
              body: JSON.stringify({
                id,
                quantity: 0,
              }),
              headers: {
                "Content-Type": "application/json",
              },
            });
            rerender();
          } catch (e) {
            console.error("Error removing product", e);
            if (this) {
              this.querySelector(".side-cart__product").classList.remove(
                "loading",
              );
            }
          }
        }
      }

      customElements.define("sidecart-product", SidecartProduct);
      customElements.define("side-cart", Sidecart);

      const sidecart = document.querySelector("side-cart");

      // override cart icon click
      document.querySelectorAll(".cart-link").forEach((link) =>
        link.addEventListener("click", (e) => {
          e.preventDefault();
          sidecart.open();
        }),
      );

      rerender();
    }
  });
  observer.observe(document.body, {
    attributes: true,
    childList: false,
    subtree: false,
    attributeFilter: ["data-pdm-features"],
  });
})();
